import React from 'react';
import styled from 'styled-components';
import eu from '../img/eu.jpg';

function Home() {
  const About = styled.p`
    color: whitesmoke;
    letter-spacing: 5px;
    font-size: 1.2rem;
    font-weight: 600;
    min-width: 10rem;
    max-width: 52.5vw;
    margin: auto 30px;
    z-index: 1;
    background: transparent;

    @media (max-width: 1000px) {
      font-size: 1.4rem;
      margin: auto 10px;
      letter-spacing: 2px;
      max-width: 100vw;
    }
  `;

  const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const Me = styled.img`
    max-height: 75%;
    min-height: 60%;
    width: auto;
    margin-left: -12.5rem;
    z-index: 0;
    opacity: 0.6;

    @media (max-width: 1000px) {
      height: 50%;
    }
  `;

  return (
    <Container>
      <h1>Home</h1>

      <About>
        Olá, eu sou o Murilo! Desenvolvedor Full-Stack Freelancer, venha conhecer
        um pouco mais sobre mim!
      </About>

      <Me src={eu} alt="Foto do Murilo" />
    </Container>
  );
}

export default Home;
